export default "__VITE_ASSET__CDSXf6G2__"